module.exports = __webpack_public_path__ + "media/images/logo-white-e0a8f95248daa0f60f8d5a0f51c5335d.svg";